/**
 * StaffPage — управление сотрудниками (placeholder Phase 4)
 */

export function StaffPage(): React.JSX.Element {
  return (
    <div className="px-4 pt-4">
      <h1 className="mb-4 text-2xl font-bold text-[var(--tg-theme-text-color)]">
        👥 Команда
      </h1>

      {/* Coming Soon */}
      <div className="flex flex-col items-center justify-center py-16">
        <div className="mb-4 text-6xl">👥</div>
        <h2 className="mb-2 text-lg font-semibold text-[var(--tg-theme-text-color)]">
          Скоро!
        </h2>
        <p className="text-center text-sm text-[var(--tg-theme-hint-color)]">
          Управление сотрудниками, приглашения,{'\n'}
          роли и расписание — в следующем обновлении.
        </p>
      </div>
    </div>
  );
}
